import { render, staticRenderFns } from "./ItemInformation.vue?vue&type=template&id=609f8694&"
import script from "./ItemInformation.vue?vue&type=script&lang=js&"
export * from "./ItemInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports